var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomania({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 0.746344C14.8739 0.264047 13.4679 6.23894e-09 12 6.23894e-09C10.5322 -4.68688e-05 9.12612 0.264047 7.82614 0.746344L6.78265 12L7.82614 23.2536C9.12608 23.736 10.5321 24 12 24C13.4678 24 14.8739 23.736 16.1739 23.2536L17.2174 12L16.1739 0.746344Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 6.84046 20.7435 2.44185 16.1739 0.746384V23.2537C20.7435 21.558 24 17.1596 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 17.1596 3.2565 21.5581 7.82602 23.2537L7.82606 0.746445C3.2565 2.44191 0 6.84038 0 12H0Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomania);
export default __webpack_public_path__ + "static/media/romania.9cb2eca385989e51d212dc35bb6e3ffc.svg";
export { ForwardRef as ReactComponent };